import { NavigateFunction } from "react-router-dom";
import { logoutOrganization } from "../Actions/Organization/AuthActions";
import store from "../store";
import OrganizationAxiosInstance from "./OrganizationAxiosInstance";

const AxiosInterceptor = (navigate:NavigateFunction) => {

    

  // Response interceptor to handle 401 errors globally
  OrganizationAxiosInstance.interceptors.response.use(
    (response) => response, // Return the response if successful
    (error) => {
        
      if (error.response && error.response.status === 401) {
        // If we receive a 401, reset the Redux state and redirect the user to the login page
        store.dispatch(logoutOrganization());
  
        // window.location.href = '/login-org'; // Redirect to login
        navigate('/login-org');
    }
      
      if(error.response && error.response.status === 403){
  
        // window.location.href = '/settings';
        navigate('/settings');
      }
      return Promise.reject(error);
    }
  );
  
};

export default AxiosInterceptor;